import {
  api_req_locid_info,
  api_req_locid_edit,
  api_req_locid_delete,
  api_req_thumbnails,
  api_req_delete_all_images_by_id
} from "../Locator/LocServices/api_request"

const UPDATE_LOC_ID_INFO = "UPDATE_LOC_ID_INFO";
const RESET_LOC_ID_INFO = "RESET_LOC_ID_INFO";
const UPDATE_LOC_SIMPLE_FINDER_MODE = "UPDATE_LOC_SIMPLE_FINDER_MODE"
const UPDATE_LOC_LOADING = "UPDATE_LOC_LOADING"
const UPDATE_LOC_REQ_RESULT = "UPDATE_LOC_REQ_RESULT"
const UPDATE_LOC_ID = "UPDATE_LOC_ID";
const UPDATE_LOC_ALERT = "UPDATE_LOC_ALERT"
const UPDATE_LOC_TOASTER = "UPDATE_LOC_TOASTER"
const UPDATE_THUMBNAILS = "UPDATE_THUMBNAILS"
const TEST = "TEST";
  
  const initialState = {
    location_id: "",
    isLoading: false,
    req_result: '',
    msgError: '',
    location_simpleFinderMode: 'show',
    location_id_resData: [],
    locAlert: {
      type: "",
      text: "",
      time: 3000,
    },
    toaster: {className: "", body: ""},
    reqThumbnails: {
      message: "",
      images: []
    },

  };
  
  const locationReducer = (state = initialState, action) => {
    //console.log(initialState)
    //console.log(state)
    //debugger
    if (action.type === UPDATE_LOC_ID_INFO) {
      const {data} = action
        const stateCopy = {
            ...state,
            location_id_resData: data.result
          };
        return stateCopy;
      }

    if (action.type === RESET_LOC_ID_INFO) {
      const {info} = action
        const stateCopy = {
            ...initialState
          };
        return stateCopy;
      }   

    if (action.type === UPDATE_LOC_SIMPLE_FINDER_MODE) {
      const {modeName} = action
      //console.log('redux hello!')
        const stateCopy = {
            ...state,
            location_simpleFinderMode: modeName
          };
        return stateCopy;
      }   
      
    if (action.type === UPDATE_LOC_LOADING) {
      const {boolValue} = action
        const stateCopy = {
            ...state,
            isLoading: boolValue
          };
        return stateCopy;
      }         

    if (action.type === UPDATE_LOC_REQ_RESULT) {
      const {strResult} = action
        const stateCopy = {
            ...state,
            req_result: strResult
          };
        return stateCopy;
      }  
      
    if (action.type === UPDATE_LOC_ID) {
      const {id} = action
        const stateCopy = {
            ...state,
            location_id: id
          };
        return stateCopy;
      }      
      
    if (action.type === UPDATE_LOC_ALERT) {
      const {payload} = action
        const stateCopy = {
            ...state,
            locAlert: payload
          };
        return stateCopy;
      }        

    if (action.type === UPDATE_LOC_TOASTER) { //toaster: {className: "", body: ""}
      const {payload} = action
        const stateCopy = {
            ...state,
            toaster: payload
          };
        return stateCopy;
      }   
      
    if (action.type === UPDATE_THUMBNAILS) {
        const {payload} = action
        const stateCopy = {
            ...state,
            reqThumbnails: payload
          };
        return stateCopy;
      }  
      
    if (action.type === TEST) {
      //console.log('redux hello!2')
        const stateCopy = {
            ...state,
            location_simpleFinderMode: 'test'
          };
        return stateCopy;
      }  

      
/*     if (action.type === FORM_INPUT_DATA) {
      const stateCopy = {
        ...state,
        rFormInputData: action.dataObj
      };
      return stateCopy;
    } 
  
    if (action.type === SET_EDIT_ID) {
      const stateCopy = {
        ...state,
        rEditId: action.id
      };
      return stateCopy;
    }  */
  
  
    return state;
  };

  export const update_loc_simpleFinderMode = (modeName) => ({ type: UPDATE_LOC_SIMPLE_FINDER_MODE, modeName});
  export const update_test = () => ({ type: UPDATE_LOC_SIMPLE_FINDER_MODE});
  export const update_loc_loading = (boolValue) => ({ type: UPDATE_LOC_LOADING, boolValue});
  export const update_loc_id = (id) => ({ type: UPDATE_LOC_ID, id});
  export const update_loc_alert = (payload) => ({ type: UPDATE_LOC_ALERT, payload});

/*   export const update_LocIdInfo = (info) => ({ type: UPDATE_LOC_ID_INFO, info });
  export const reset_LocIdInfo = () => ({ type: RESET_LOC_ID_INFO}); 
      if (action.type === UPDATE_THUMBNAILS) {
        const {payload} = action     thumbnails: {
      message: "",
      images: []
    },
        
        */

  export const reset_LocIdInfo = () => ({ type: RESET_LOC_ID_INFO});

  export const test = (locationId, chat_id, token) => (dispatch) => {
    //console.log('ggggdisp')
    return dispatch({
      type: UPDATE_LOC_ID_INFO,
      locationId: locationId,
      chat_id: chat_id,
      token: token
    });
  
  };

  export const getThumbnails = (locatorId) => (dispatch) => {
    //console.log("Delete Action")
    //console.log(locationId, token)
    dispatch(update_loc_loading(true))

    return api_req_thumbnails(locatorId)
    .then(
      (response) => {
        console.log(response.data)
        dispatch({type: UPDATE_THUMBNAILS, payload: {message: response.data.message, images: response.data.images}})

        dispatch(update_loc_loading(false))
        return Promise.resolve();
      },
      (error) => {
        console.log(error.message)
        dispatch({type: UPDATE_THUMBNAILS, payload: {message: error.message, images: []}})

        dispatch(update_loc_loading(false))
        return Promise.reject();
      }

    )


  }


  //    if (action.type === UPDATE_LOC_TOASTER) { //toaster: {className: "", body: ""}
  export const activateLocToaster = (payload) => (dispatch) => {
    
    const delay = (ms) => {
      return new Promise((resolve, reject) => {
          setTimeout(resolve, ms)
      })
    }

    const toastDelay = async () => {
      dispatch({
        type: UPDATE_LOC_TOASTER,
        payload: payload
      });
      
      const newText = await delay(6000).then(() => 'hhhhh')
      
      dispatch({
        type: UPDATE_LOC_TOASTER,
        payload: {className: "", body: ""} //reset
      });

    }

    toastDelay();

  
  };
  
  export const reqLocId_delete = (locationId, token) => (dispatch) => {
    //console.log("Delete Action")
    //console.log(locationId, token)
    dispatch(update_loc_loading(true))

    return api_req_locid_delete(locationId, token)
    .then(
      (response) => {
        //console.log(response.data.result)
        api_req_delete_all_images_by_id(locationId) //delete all images by that id

        dispatch({type: UPDATE_LOC_REQ_RESULT, strResult: response.data.result})
        dispatch({ type: RESET_LOC_ID_INFO }); //"show" -default
        //dispatch(update_loc_simpleFinderMode("show"))
        //dispatch(reqLocId_findInfo(id, chat_id, accessToken)) //get ne info again
        dispatch(update_loc_loading(false))
        window.location.href = '/locator_simple_finder'; //redirect to finder page
        return Promise.resolve();
      },
      (error) => {
        dispatch({type: UPDATE_LOC_REQ_RESULT, strResult: error.msg})
        dispatch({ type: RESET_LOC_ID_INFO }); //"show" -default
        //dispatch(update_loc_simpleFinderMode("show"))
        //dispatch(reqLocId_findInfo(id, chat_id, accessToken)) //
        dispatch(update_loc_loading(false))
        window.location.href = '/locator_simple_finder'; //redirect to finder page
        return Promise.reject();
      }

    )


  }


  export const reqLocId_findInfo = (locationId, chat_id, token) => (dispatch) => {

    dispatch(update_loc_loading(true))

    return api_req_locid_info(locationId,chat_id,token)
    .then(
      (response) => {
        dispatch(update_loc_id(locationId))
        //console.log(response.data.result)
        dispatch({type: UPDATE_LOC_REQ_RESULT, strResult: "OK"})

        dispatch({
          type: UPDATE_LOC_ID_INFO,
          data: response.data
    
        });
        //console.log(response)
        dispatch(update_loc_simpleFinderMode("show"))
        dispatch(update_loc_loading(false))
        if (typeof(response.data.result[0]) === 'undefined') {
          dispatch(update_loc_alert(
            {
              "type": "alert-danger",
              "text": "0 records found",
              "time": 2000
            }
          ))
        }
        //console.log(typeof(response.data.result[0]))
        return Promise.resolve();
      },
      (error) => {
        console.log(error.message)
        dispatch({ type: RESET_LOC_ID_INFO });
        dispatch({type: UPDATE_LOC_REQ_RESULT, strResult: error.message})
        dispatch(update_loc_simpleFinderMode("show"))
        dispatch(update_loc_loading(false))

          dispatch(update_loc_alert(
            {
              "type": "alert-danger",
              "text": error.message,
              "time": 1000
            }
          ))

        return Promise.reject();
      }

    )
  };  

  export const reqLocId_edit = (formData) => (dispatch) => {
    //console.log(formData)
    const {id, chat_id, accessToken, gr_tags, url, text, description} = formData
    //console.log(id, chat_id, accessToken, gr_tags, url, text, description)
    //console.log("it's me 4 redux")

    dispatch(update_loc_loading(true))

    const data = {

      "location_id": id.toString(), 
      "chat_id": chat_id.toString(),
      "gr_tags": gr_tags,
      "url": url,
      "text": text,
      "description": description
    }

    return api_req_locid_edit(accessToken, data)
    .then(
      (response) => {
        //console.log(response.data.result)
        dispatch({type: UPDATE_LOC_REQ_RESULT, strResult: response.data.result})
        //dispatch(update_loc_simpleFinderMode("show"))
        dispatch(reqLocId_findInfo(id, chat_id, accessToken)) //get ne info again
        //dispatch(update_loc_loading(false))

        return Promise.resolve();
      },
      (error) => {
        dispatch({type: UPDATE_LOC_REQ_RESULT, strResult: error.msg})
        //dispatch(update_loc_simpleFinderMode("show"))
        //dispatch(reqLocId_findInfo(id, chat_id, accessToken)) //
        dispatch(update_loc_loading(false))

        return Promise.reject();
      }

    )


  };  

  export default locationReducer;  